<template>
  <b-row>
    <b-col sm="6" lg="6" xl="4" class="col-xxl-3" v-for="(item, index) in fields" :key="index">
      <modal-select :modal="item.modal" :name="item.field" :readonly="false" v-on:select-item="selectItem($event, item.field, item.foreign)" :placeholder="item.placeholder" label="" ></modal-select>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'grid-filters',
  props: ['fields', 'gridData'],
  data() {
    return {
      filters: {},
      showModal: false,
      item: {
        id: null,
        label: ''
      }
    }
  },
  methods: {
    selectItem(e, field, foreign) {
      if(e.item) {
        this.filters[field] = e.item[foreign]
        this.$parent.$refs[this.gridData].applyFilter(field, e.item[foreign])
      } else {
        this.filters[field] = null
        this.$parent.$refs[this.gridData].removeFilter(field)
      }
    }
  },
  mounted() {
    // this.$refs.input.value = this.item.id;
  },
  created() {
    this.item.id = typeof this.itemId == 'undefined' ? '': this.itemId
    this.item.label = this.itemName
  }
}
</script>
